export default __webpack_public_path__ + "static/media/Vesp.3d4abce8.png";